import { useContext } from 'react';

import reactReplacePlaceholder from 'react-replace-placeholder';

import StringsContext from '../Contexts/StringsContext';

import type { CodeshareData } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ArrivalsDepartures';

import STYLES from './Codeshare.module.scss';

interface CodeshareProps {
  codeshares?: CodeshareData[];
}

const Codeshare = ({ codeshares = [] }: CodeshareProps) => {
  const strings = useContext(StringsContext);
  const operatorName = codeshares
    .map(
      ({ airlineId, airlineName, flightNumber }) =>
        `${airlineName} (${airlineId}${flightNumber})`,
    )
    .join(', ');

  return (
    <div className={STYLES.Codeshare}>
      {reactReplacePlaceholder(
        strings.falcon_arrivals_departures_board_codeshare_new,
        {
          operator_name: operatorName,
        },
        '{',
        '}',
      )}
    </div>
  );
};

export default Codeshare;
